import type { SVGProps } from "react";

export const PaperIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className="fill-current"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.6 0C10.4837 0 11.2 0.716344 11.2 1.6H12C12.6365 1.6 13.2468 1.85304 13.6969 2.30313C14.147 2.75321 14.4 3.36348 14.4 4V15.2C14.4 15.8365 14.147 16.4468 13.6969 16.8969C13.2468 17.347 12.6365 17.6 12 17.6H2.4C1.76348 17.6 1.15321 17.347 0.703125 16.8969C0.253038 16.4468 0 15.8365 0 15.2V4C0 3.36348 0.253038 2.75321 0.703125 2.30313C1.15321 1.85304 1.76348 1.6 2.4 1.6H3.2C3.2 0.716344 3.91634 0 4.8 0H9.6ZM2.4 3.2C2.18783 3.2 1.9844 3.28435 1.83437 3.43438C1.68435 3.5844 1.6 3.78783 1.6 4V15.2L1.60391 15.2789C1.62206 15.4621 1.70306 15.6343 1.83437 15.7656C1.9844 15.9157 2.18783 16 2.4 16H12C12.2122 16 12.4156 15.9157 12.5656 15.7656C12.7157 15.6156 12.8 15.4122 12.8 15.2V4C12.8 3.78783 12.7157 3.5844 12.5656 3.43438C12.4343 3.30306 12.2621 3.22206 12.0789 3.20391L12 3.2H11.2C11.2 4.08366 10.4837 4.8 9.6 4.8H4.8C3.91634 4.8 3.2 4.08366 3.2 3.2H2.4ZM4.8 3.2H9.6V1.6H4.8V3.2Z"
      fill="currentColor"
    />
  </svg>
);
